import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import "./addOurFranchise.css";
import LoadingPage from "../Loading/loading";
import { deleteOurFranchises, getOurFranchises } from "../../api/ourFranchise";
import { proxy } from "../../config";

const OurFranchiseComponent = (props) => {
  const [ourFranchises, setOurFranchises] = useState(null);
  const [id, setId] = useState("");

  useEffect(() => {
    setOurFranchises(null);
    getOurFranchises().then((result) => {
      setOurFranchises(result.data.response);
    });
  }, []);

  const deleteOurFranchise = (id) => {
    deleteOurFranchises(id).then((result) => {
      setOurFranchises(
        ourFranchises.filter((ourFranchise) => ourFranchise._id !== id),
      );
    });
  };

  return (
    <>
      {ourFranchises === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            {ourFranchises?.map((ourFranchise) => (
              <div key={ourFranchise.id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <img
                      className="image-slider"
                      src={`${proxy}/${ourFranchise.image}`}
                      width="90%"
                    />
                    <p className="line">
                      <span className="label">Name:</span> {ourFranchise.name}
                    </p>
                    <p className="line">
                      <span className="label">Since:</span> {ourFranchise.since}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {ourFranchise?.createdAt.split("T")[0]}
                    </p>
                    {id === ourFranchise._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this franchise?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                deleteOurFranchise(ourFranchise._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {props.isSuper && (
                  <>
                    {id !== ourFranchise._id && (
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            setId(ourFranchise._id);
                          }}
                          className="action-btn remove-btn"
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OurFranchiseComponent;
